export const VENUE_CREATE_INITIAL_VALUES = {
  id: '',
  locationName: '',
  address: {
    id: '',
    name: '',
    location: {
      lat: 0,
      lng: 0,
      infoAddress: {
        city: '',
        state: '',
        country: '',
        zip: '',
        countryCode: '',
      },
    },
  },
  openingTimings: '',
  operatingHours: [],
  venueType: null,
  venueSubType: { id: '', name: 'None' },
  venueContact: {
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    role: '',
  },
};

export const STATION_PLACEMENT_ASSIGN_INITIAL_VALUES = {
  name: '',
  placementType: null,
  distributionChannel: null,
  location: { latitude: 0.0, longitude: 0.0 },
  sameOpeningTimingsAsVenue: true,
  openingTimings: '',
  attachment: {
    imei: '',
    fullStationScreen: '',
    stationLeftSide: '',
    stationRightSide: '',
    stationFrontSide: '',
    stationPerspective: '',
    additional: '',
  },
  station: null,
  placementId: undefined,
  isPlacementAssignedStation: false,
  assignedStationId: undefined,
  assignedStationImei: undefined,
  assignedStationType: undefined,
  assignedStationSerialNumber: undefined,
  swapReasonId: undefined,
  swapNote: undefined,
  isRelocationFlow: false,
  relocationReasonId: undefined,
  relocationNote: undefined,
};

export const INITIAL_VALUES = {
  isExistingVenue: false,
  venue: { ...VENUE_CREATE_INITIAL_VALUES },
  placement: { ...STATION_PLACEMENT_ASSIGN_INITIAL_VALUES },
  swapReasonId: undefined,
  relocationReasonId: undefined,
  swapNote: undefined,
  relocationNote: undefined,
};
